import { createSelector } from 'reselect';

import { RootState } from 'app/store';

import { RequestStatus } from 'constants/enums';

export const selectApplications = (state: RootState) =>
  state.applications.applications;

export const selectApplicationsDetails = (state: RootState) => {
  return state.applications;
};

export const selectActiveUserId = (state: RootState) =>
  state.sidebar.activeUserId;

export const selectActiveApplication = createSelector(
  [selectApplications, selectActiveUserId],
  (applications, activeApplicationId) =>
    applications.find((application) => application.id === activeApplicationId)
);

export const selectRequestStatus = (state: RootState) =>
  state.applications.status;

export const selectIsLoading = (state: RootState) =>
  state.applications.status === RequestStatus.Loading ||
  state.applications.status === RequestStatus.Idle;

export const selectRecentApplications = createSelector(
  [selectApplications],
  (applications) => applications.slice(0, 5)
);
